const useIncidentPreviewDrawerStyles = () => {
    return {
        scoreBreakdownAccordionStyles: {
            '.MuiAccordion-root:before': {
                backgroundColor: (theme) => `${theme.palette.background.neutral} !important`
            },
            '&.-MuiPaper-root-MuiAccordion-root': {
                boxShadow: 'none !important',
                borderRadius: '0 !important'
            },
            '&.Mui-expanded': {
                boxShadow: 'none !important',
                borderRadius: (theme) => `${theme.shape.borderRadius} !important`,
                backgroundColor: (theme) => `${theme.palette.background.neutral} !important`
            },
            '.MuiAccordionSummary-root': {
                padding: (theme) => `${theme.spacing(1)} !important`,
                paddingLeft: (theme) => `${theme.spacing(1)} !important`,
                paddingRight: (theme) => `${theme.spacing(1)} !important`,
                background: theme => `${theme.palette.background.neutral} !important`
            },
            '.MuiAccordionDetails-root': {
                padding: (theme) => `${theme.spacing(1)} !important`,
                paddingTop: (theme) => `${theme.spacing(1)} !important`,
            }
        }
    };
};
export default useIncidentPreviewDrawerStyles;
